import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=48248228&"
import script from "./countDown.vue?vue&type=script&lang=js&"
export * from "./countDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports